// ----------------------------------------------------------------------
export const Badge = () => {
    return {
        MuiBadge: {
            styleOverrides: {
                dot: { width: 10, height: 10, borderRadius: '50%' }
            }
        }
    };
};
//# sourceMappingURL=Badge.js.map